export default __webpack_public_path__ + "e2f6af3c3bc68effaf4944839c5bd938.wav";